module.exports = __webpack_public_path__ + "static/media/universal-2.3d06dfa4.png";